import { all, putResolve, takeLatest } from 'redux-saga/effects';
import actions from '../../actions';
import * as DeleteVideoTagMethods from '../../utils/api/field/DeleteVideoTagData';

function* DeleteVideoTagData(payload) {
  const deletePayload = payload?.payload?.deletePayload || payload.payload;
  const refreshPayload = payload?.payload?.refreshPayload;

  const promise = DeleteVideoTagMethods.DeleteVideoTagData(deletePayload);
  const { res } = yield promise;
  yield putResolve({ type: actions.DeleteVideoTagAction.DELETEVIDEOTAG_RECEIVED, data: res.Response });

  if (refreshPayload) {
    yield putResolve({
      type: actions.analysisAction.REQUEST_ANALYSIS_DATA,
      payload: refreshPayload
    });
    yield putResolve({
      type: actions.analysisAction.REQUEST_SCREENER_ANALYSIS_DATA,
      payload: refreshPayload
    });
  }
}

export  { DeleteVideoTagData }